module.exports = __webpack_public_path__ + "img/logo_marca.829cc125.png";